import { useState } from 'react';
import { Dropdown, DropdownItem } from 'react-nested-dropdown';
import './menu.css';
import 'react-nested-dropdown/dist/styles.css';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { getImageUrl } from '../../../../../utils/image-helper/get-image-url';


export const Menu = () => {
    const [isShortcutKeysModalOpen, setIsShortcutKeysModalOpen] = useState(false);

    const menuitems: { menuitemName: string; items: DropdownItem[] }[] = [
        {
            menuitemName: 'Segítség',
            items: [
                {
                    label: 'Gyorsbillentyűk',
                    onSelect: () => setIsShortcutKeysModalOpen(true)
                }
            ]
        }
    ];

    return (
        <>
            <div className="process-editor-menu">
                {
                    menuitems.map(menuitem => (
                        <Dropdown items={menuitem.items} key={menuitem.menuitemName}>
                            {({ isOpen, onClick }) => (
                                <span className='menuitem' onClick={onClick}>
                                    {menuitem.menuitemName}
                                </span>
                            )}
                        </Dropdown>
                    ))
                }
            </div>

            <Modal
                className="shortcut-keys-modal"
                isOpen={isShortcutKeysModalOpen}
                toggle={() => setIsShortcutKeysModalOpen(!isShortcutKeysModalOpen)}
            >
                <ModalHeader className="d-block">
                    <div className="d-flex justify-content-between align-items-center blue-font">
                        <b>Gyorsbillentyűk</b>
                        <img
                            style={{ width: '50px', padding: '10px 10px 0 0' }}
                            src={getImageUrl('close-button.png')}
                            alt="close-button"
                            title="Bezárás"
                            className="cursor-pointer"
                            onClick={() => setIsShortcutKeysModalOpen(false)}
                        />
                    </div>
                </ModalHeader>
                <ModalBody>
                    <p>
                        Ugrás a modellhez: dupla kattintás
                    </p>
                    <h6>Kijelölt objektum változtatása:</h6>
                    Pozició: "<b>t</b>"
                    <br />
                    Rotáció: "<b>r</b>"
                </ModalBody>
            </Modal>
        </>
    );
};